import { Observable, map, of } from "rxjs";
import { ParkerFunctionExecutor } from "./parker-function-executor.class";
import { ParkerClient, ParkerDTO } from "src/app/base/models/models.swagger.generated";
import { TranslateService } from "@ngx-translate/core";
import { ParkerInfo } from "../parker-execution-status";

export class UnlinkParkerExecutor extends ParkerFunctionExecutor {
  constructor(numTotalRecordsToWorkOn: number, private parkerClient: ParkerClient, private translateService: TranslateService) {
    super(numTotalRecordsToWorkOn);
  }

  protected prepare(): Observable<void> {
    return of(null); // nothing to prepare
  }

  protected executeFunctionOnParker(parker: ParkerDTO): Observable<number> {
    return this.parkerClient.unlinkParkerFromUser(parker.id).pipe(map(() => parker.id));
  }

  protected preFilterParkersAndUpdateExecutionStatus(parkers: ParkerDTO[]): ParkerDTO[] {
    const parkersToUnlink = [];
    parkers?.forEach(parker => {
      if (!parker.linkedUserUserName) {
        this.executionStatus.push({
          status: 'warning',
          message: this.translateService.instant('i18n.domain.parker-administration.overview.function-dialog.function-status-dialog.message-parker-not-linked'),
          parkerInfo: new ParkerInfo(parker)
        });
      }
      else {
        parkersToUnlink.push(parker);
      }
    });
    return parkersToUnlink;
  }
}
